import { TIMING } from '../config/timing.js';
import { distanceM } from '../geo/distance.js';
/**
 * Der Sendetakt eines Clients.
 *
 * Steht hier und nicht in der Weboberfläche, weil sich der Fahrsimulator
 * genauso verhalten muss wie ein echtes Gerät. Täte er es nicht, prüfte die
 * Abnahme von Stufe 1 etwas anderes als das, was später im Auto läuft.
 */
/**
 * Ist diese Messung an der Reihe?
 *
 * In Bewegung einmal je Sekunde. Im Stillstand alle zehn Sekunden — an einer
 * langen Ampel oder bei der Einkehr bringt jede Sekunde dieselbe Position
 * niemandem etwas und kostet nur Akku und Datenvolumen.
 *
 * Als reine Funktion herausgezogen, weil sie ohne Browser prüfbar sein muss:
 * ein zu schneller Takt fällt im Fahrbetrieb nicht auf, ein zu langsamer erst
 * dann, wenn jemand tatsächlich abgehängt wird.
 */
export function isDueForSending(previous, next) {
    if (previous === null) {
        return true;
    }
    const vergangen = next.recordedAt - previous.recordedAt;
    const bewegt = (next.speedMps ?? 0) >= TIMING.movingSpeedMps ||
        distanceM(previous, next) >= TIMING.movingDistanceM;
    return vergangen >= (bewegt ? TIMING.positionIntervalMovingMs : TIMING.positionIntervalIdleMs);
}
//# sourceMappingURL=cadence.js.map